"use client";

import React from "react";
import Link from "next/link";
import { Home, Users, Gamepad, User, MoreHorizontal } from "lucide-react";

interface BottomBarProps extends React.HTMLAttributes<HTMLElement> {
  className?: string;
}

export function BottomBar({ className = "", ...props }: BottomBarProps) {
  return (
    // 모바일 화면에서만 표시되는 하단 네비게이션 바
    // nav 모바일이면 표시하고, PC 버전은 안보이도록 css 처리
    <nav
      className={`
        md:hidden
        backdrop-blur-sm
        bg-white
        dark:bg-background
        border-t
        fixed 
        bottom-0 
        left-0 
        w-full 
        h-16 
        px-2 
        z-[1000px]
        transition-all 
        duration-[400ms] 
        ease-out
        translate-y-0
        ${className}
      `}
      {...props}
    >
      <div className="grid grid-cols-5 h-full">
        {/* 홈 (활성화된 탭은 텍스트 컬러를 #b00000 적용) */}
        <Link
          href="/"
          className="flex flex-col items-center justify-center text-[10px] gap-[7px] cursor-pointer text-[#b00000]"
          tabIndex={-1}
        >
          <Home size={22} />
          <span>홈</span>
        </Link>

        {/* 커뮤니티 */}
        <Link
          href="/bbs"
          className="flex flex-col items-center justify-center text-[10px] gap-[7px] cursor-pointer text-[#48546e]"
          tabIndex={-1}
        >
          <Users size={22} />
          <span>커뮤니티</span>
        </Link>

        {/* 게임 */}
        <Link
          href="/games"
          className="flex flex-col items-center justify-center text-[10px] gap-[7px] cursor-pointer text-[#48546e]"
          tabIndex={-1}
        >
          <Gamepad size={22} />
          <span>게임</span>
        </Link>

        {/* 내 페이지 */}
        <Link
          href="/account"
          className="flex flex-col items-center justify-center text-[10px] gap-[7px] cursor-pointer text-[#48546e]"
          tabIndex={-1}
        >
          <User size={22} />
          <span>내 페이지</span>
        </Link>

        {/* 더보기 */}
        <Link
          href="/menu"
          className="flex flex-col items-center justify-center text-[10px] gap-[7px] cursor-pointer text-[#48546e]"
          tabIndex={-1}
        >
          <MoreHorizontal size={22} />
          <span>더보기</span>
        </Link>
      </div>
    </nav>
  );
}
